import React from 'react';

const Modal = (props: { children: React.ReactNode }) => {
  return (
    <div className='fixed z-50 top-0 left-0 w-full h-full'>
      <div className='fixed w-screen h-screen bottom-0 bg-black opacity-50 overlay'></div>
      <div className='flex items-center justify-center h-full'>
        <div className='relative flex flex-col gap-4 m-2 p-4 md:p-8 bg-white max-h-[90%] overflow-auto w-full md:max-w-xl shadow-popup popup'>
          {props.children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
